<template>
  <div :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }">
    <header-o :model="headerData"></header-o>

    <div v-if="loading" class="text-gray-500 mt-4">Loading rankings...</div>

    <div v-else-if="rankings && rankings.leaderboard && rankings.leaderboard.length > 0" class="margin-10" style="margin-top: -180px; padding-bottom: 20px;">
      <div style="margin-right: 5px; margin-left: 5px;">
        <div
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
          }"
          class="past-history-section common-section height-cus"
          style="overflow: hidden; border-radius: 10px; padding-bottom: 10px;"
        >
          <!-- Banner Image -->
          <div v-if="rankings.banner_url" style="width: 100%;">
            <img
              style="width: 100%; border-top-left-radius: 10px; border-top-right-radius: 10px;"
              :src="rankings.banner_url"
            />
          </div>

          <div class="past-history-title text-center" style="padding: 10px 0px;">
            <span style="font-weight: 700; color: #323232;">LeaderBoard</span>
          </div>

          <!-- Winner Section Start -->
          <div
            class="winner-section text-center"
            style="border-top: 1px solid #C8C8C8;"
            v-if="top_winners && top_winners.length >= 3"
          >
            <div class="title" style="margin-top: 10px;">
              <span style="font-weight: 700; color: #323232;">Winners</span>
            </div>

            <div class="row align-items-center" style="justify-content: center; display: flex;">
              <div class="col-3" style="max-width: 23%;">
                <div class="winner-block">
                  <img src="@/assets/rank-2.svg" alt="rank-2" class="img-fluid" />
                  <p style="color: #323232 !important; font-size: 14px;">
                    {{ top_winners[1].user_name }}
                  </p>
                </div>
              </div>
              <div class="col-2">
                <div class="winner-block first-rank">
                  <img src="@/assets/rank-1.svg" alt="rank-1" class="img-fluid" />
                  <p style="color: #323232 !important; font-size: 15px; font-weight: 600;">
                    {{ top_winners[0].user_name }}
                  </p>
                </div>
              </div>
              <div class="col-3">
                <div class="winner-block">
                  <img src="@/assets/rank-3.svg" alt="rank-3" class="img-fluid" />
                  <p style="color: #323232 !important; font-size: 14px;">
                    {{ top_winners[2].user_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- Winner Section End -->

          <!-- History Table Start -->
          <div class="history-table" style="border-top: 1px solid #C8C8C8; overflow: hidden;">
            <div class="table-scroll">
              <table
                class="table table-borderless leaderboard-table"
                style="width: 100%; table-layout: fixed; margin-bottom: 0;"
              >
                <thead>
                  <tr>
                    <th style="width: 20%; padding: 8px; color: #323232;">Rank</th>
                    <th style="width: 35%; padding: 8px; color: #323232;">User</th>
                    <th style="width: 22%; padding: 8px; color: #323232;">Score</th>
                    <th style="width: 23%; padding: 8px; color: #323232;">{{ currency_label }}</th>
                  </tr>
                </thead>

                <!-- Current user's rank -->
                <tbody>
                  <tr
                    v-if="rankings.user_data"
                    :style="{
                      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee'
                    }"
                    class="your-rank"
                  >
                    <td style="padding: 8px;">{{ rankings.user_data.rank }}</td>
                    <td
                      class="name"
                      style="padding: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                    >
                      {{ rankings.user_data.user_name }}
                    </td>
                    <td style="padding: 8px;">{{ rankings.user_data.score }}</td>
                    <td style="padding: 8px;">
                      {{ rankings.user_data.prize == 0 ? "0" : prize(rankings.user_data.prize) || "-" }}
                    </td>
                  </tr>
                </tbody>

                <!-- Leaderboard List -->
                <tbody style="color: #544e4e;" v-for="(item, index) in rankings.leaderboard" :key="index">
                  <tr>
                    <td style="padding: 8px;">{{ item.rank }}</td>
                    <td
                      class="name"
                      style="padding: 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                    >
                      {{ item.user_name }}
                    </td>
                    <td style="padding: 8px;">{{ item.score }}</td>
                    <td style="padding: 8px;">
                      {{ item.prize == 0 ? "0" : prize(item.prize) || "" }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- History Table End -->
        </div>
      </div>
    </div>

    <div
      :style="{ backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff' }"
      v-else
      class="height-90 border-radius-5 align-ver center-hor bg-light"
    >
      <div style="display: flex; justify-content: center; align-items: center; width: 100%">
        <img src="@/assets/no-data.svg" class="w20" style="width: 25%;" />
      </div>
      <div style="font-weight: 800; font-size: 16px; margin-top: 20px;">
        No leaderboard data available.
      </div>
    </div>
  </div>
</template>

<script>
import OverlapHeader from "@/components/overlapped-header";
import { globals } from "@/mixins/globals";
import axios from "axios";

export default {
  name: "LeaderboardRankings",
  components: { "header-o": OverlapHeader },
  mixins: [globals],
  data() {
    return {
      headerData: { onlyHeader: true, balance: true },
      rankings: null,
      loading: false,
      error: null,
      leaderboardId: null,
      leaderboardTitle: "Leaderboard",
      currency_label: "Prize",
      top_winners: []
    };
  },
  mounted() {
    this.leaderboardId = this.$route.params.id;
    this.fetchLeaderboard();
  },
  computed: {
    isDarkTheme() {
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.isDarkTheme) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    offersCardBgColor() {
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.offersCardBgColor) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null;
    },
    mainBgColor() {
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.mainBgColor) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null;
    }
  },
  methods: {
    prize(itemVal) {
      if (typeof itemVal == "string") {
        var val = itemVal.toString().split(" - ");
        if (val.length > 0 && val[0] == val[1]) {
          return val[0];
        } else {
          return itemVal;
        }
      }
      if (typeof itemVal == "number") {
        return itemVal;
      }
      return itemVal;
    },
    async fetchLeaderboard() {
      this.loading = true;
      this.error = null;

      try {
        const url = `${this.$store.getters.flyyDomain}/bonanza_leaderboard_rankings/${this.leaderboardId}`;
        const headers = this.$store.getters.headers;

        const res = await axios.get(url, { headers });

        if (res.data && res.data.data) {
          this.leaderboardTitle = res.data.data.title || "Leaderboard";
          this.$store.state.headTitle = res.data.data.title;
          this.rankings = res.data.data;
          this.currency_label = res.data.data.prize_type || "Prize";

          // Extract top 3 winners
          this.top_winners = [];
          if (res.data.data.leaderboard && res.data.data.leaderboard.length > 0) {
            res.data.data.leaderboard.forEach((l, i) => {
              if (i <= 2) {
                this.top_winners.push(l);
              }
            });
          }
        } else {
          this.rankings = null;
        }
      } catch (err) {
        this.error = "Failed to fetch leaderboard rankings";
        console.error(err);
        this.rankings = null;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";

.table-scroll {
  max-height: 350px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.table-scroll::-webkit-scrollbar {
  width: 4px;
}

.table-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}

.leaderboard-table {
  width: 100%;
  border-collapse: collapse;
}

.leaderboard-table th,
.leaderboard-table td {
  border: none;
  padding: 8px;
  text-align: center;
}

.leaderboard-table th {
  font-weight: bold;
}

.your-rank {
  font-weight: bold;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .height-cus {
    min-height: 100vh;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .height-cus {
    height: 100vh;
  }
}
</style>
